// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider2023_slider__4_Q_H","slider_light":"Slider2023_slider_light___fZNX","arrow":"Slider2023_arrow__yvUvS","arrow_right":"Slider2023_arrow_right__aDYTM"};